import { useState } from "react";
import "./form.css";
import { type } from "@testing-library/user-event/dist/type";

function Form({ additem, setStatus, status, dispatch, oneTask, button }) {
  // console.log(
  //   Array.from({ length: 20 }, (_, i) => i + 1).map((num) => {
  //     return (
  //       <option value={num} key={num}>
  //         {num}
  //       </option>
  //     );
  //   })
  // );
  let allStatus = ["Done", "Pending"];

  function handleSubmit(e) {
    e.preventDefault();
    const taskObj = {
      id: Date.now(),
      status,
      oneTask,
    };

    // console.log(taskObj);
    additem(taskObj);
    dispatch({ type: "oneTask", payload: "" });
    dispatch({ type: "button", payload: "ADD" });
  }

  return (
    <form className="tasks" onSubmit={handleSubmit}>
      <h3 className="add">add your task</h3>
      <div className="all__tasks">
        <select
          name=""
          id=""
          value={status}
          onChange={(e) =>
            dispatch({ type: "status", payload: e.target.value })
          }
        >
          {Array.from({ length: 2 }, (_, i) => allStatus[i]).map(
            (num, index) => {
              return (
                <option value={num} key={index}>
                  {num}
                </option>
              );
            }
          )}
          ;
        </select>
        <input
          type="text"
          value={oneTask}
          onChange={(e) =>
            dispatch({ type: "oneTask", payload: e.target.value })
          }
          id="inputForm"
        />
        <button className="add">{button}</button>
      </div>
    </form>
  );
}

export default Form;
